export * from './oneTrustWeb';
export * from './oneTrustMobile';
